export const FEATURE_FLAG_ROUTES = {
  get: '/feature-flags',
};
